import { Component, DestroyRef, inject, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../../app.config';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { getRequestLandWithRegExForPostalCode } from '../../../../common/factory/form.default.factory';
import { FormService } from '../../../../common/form.service';
import { makeFieldsRequiredOrNotRequired } from '../../../../common/formValidationHelper';
import { ValidationService } from '../../../../common/validation.service';
import { leapDayValidator } from '../../../../common/validators';
import { ValueListsService } from '../../../../common/value-lists.service';
import { loadValueLists, ValueList } from '../../../../common/valueListHelper';
import { AppConfig } from '../../../../models/config/app-config';
import { ValueListItem } from '../../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-eu-buerger',
  templateUrl: './eu-buerger.component.html',
  styleUrls: ['./eu-buerger.component.scss']
})
export class EuBuergerComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();

  landListItems: ValueListItem[];
  staatsangehoerigkeitListItems: ValueListItem[];

  geschlechtListItems: ValueListItem[];
  private readonly destroyRef = inject(DestroyRef);

  private readonly REQUIRED_FIELDS : string[] = [
    'geschlecht',
    'geburtsdatum',
    'geburtsort',
    'staatsangehoerigkeit'
  ];

  constructor(formBuilder: FormBuilder,
              assistantPopoverService: AssistantPopoverService,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              private formService: FormService,
              @Inject(APP_CONFIG) public appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    // Initialize form
    this.form = formBuilder.group({

      // Person
      familienname: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.familienname')],
      vorname: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.vorname')],
      geschlecht: [null, validationService.getValidators('referenz.ansprechpartner.geschlecht')],
      geburtsdatum: [null, [...validationService.getValidators('referenz.ansprechpartner.geburtsdatum'), leapDayValidator]],
      geburtsort: [null, validationService.getValidators('referenz.ansprechpartner.geburtsort')],
      staatsangehoerigkeit: [null, validationService.getValidators('referenz.ansprechpartner.staatsangehoerigkeit')],
      strasse: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.strasse')],
      hausnummer: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.hausnummer')],
      plz: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.plz')],
      ort: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.ort')],
      land: [null, validationService.getValidators('referenz.ansprechpartner.anschrift.land')],
      telefon: [null, validationService.getValidators('referenz.ansprechpartner.kontaktdaten.telefon')],
      email: [null, validationService.getValidators('referenz.ansprechpartner.kontaktdaten.email', false, true)],
      abweichendNachname: [null, validationService.getValidators('referenz.ansprechpartner.abweichendeSchreibweiseNachname')],
      abweichendVorname: [null, validationService.getValidators('referenz.ansprechpartner.abweichendeSchreibweiseVorname')],
      andereNamen: [null, validationService.getValidators('referenz.ansprechpartner.andereNamen')],
      fruehereNamen: [null, validationService.getValidators('referenz.ansprechpartner.fruehereNamen')]
    });

    makeFieldsRequiredOrNotRequired(this.form, this.validationService, true, this.REQUIRED_FIELDS);
  }

  ngOnInit() {

    // This call is required to enable the status bar validation
    super.ngOnInit();

    const valueLists: ValueList[] = [
      { name: 'land', property: 'landListItems' },
      { name: 'staatsangehoerigkeit', property: 'staatsangehoerigkeitListItems' },
      { name: 'geschlecht', property: 'geschlechtListItems' }
    ];

    loadValueLists(this.valueListsService, valueLists, this, this.subscriptions);
    this.formService.initControlWithDefaultValueAndSetRegExBasedOnValueToAnother(getRequestLandWithRegExForPostalCode(this.form, this.destroyRef));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
